import {RootState} from '../../store';
import {BillableUnit} from './types';

export const selectionSelector = (state: RootState): Record<string, BillableUnit> =>
    state['billable-units'].selection as Record<string, BillableUnit>;
